import styled from 'styled-components';

export const Control = styled.section`
	grid-column: ${props => props.column};
	grid-row: ${props => props.row};
`;